import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'recrewt-info-card',
  templateUrl: './info-card.component.html',
  styleUrls: ['./info-card.component.scss'],
})
export class InfoCardComponent {
  @Input() title = '';

  @Input() desc = '';
}
